import "./App.css";
import Login from "./pages/Login";
import ClubProjects from "./pages/ClubProjects";
import React, { useState } from "react";
import { Router } from "@reach/router";
import Instance from "./pages/Instance";
import Project from "./pages/Project";
import Insights from "./pages/Insights";
import NewClient from "./pages/NewClient";
import EditClient from "./pages/EditClient";
import Help from "./pages/Help";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import { Container } from "./styles/Container";
import { SubContainer } from "./styles/Container";
import ErrorDisplay from "./components/ErrorDisplay";

function App() {
  const isLoggedIn =
    window.localStorage.getItem("loggedIn") === "true" ? true : undefined;
  const [loggedIn, setLoggedIn] = useState(isLoggedIn | false);

  return (
    <Container>
      <SubContainer loggedIn={loggedIn}>
        {loggedIn ? <Nav setLoggedIn={setLoggedIn} /> : <></>}
        <Router>
          {loggedIn ? (
            <>
              <ClubProjects path="/" />
              <Instance path="/:projectID/new-instance" />
              <Instance path="/:projectID/:instanceID" />
              <Project path="/project/:projectID" />
              <Insights path="/:projectID/insights" />
              <NewClient path="/create-client" />
              <EditClient path="/:projectID/edit-client" />
              <Help path="/help-and-resources" />
              <ErrorDisplay
                default
                status={404}
                msg={"Uh oh, we can’t seem to find the page you’re looking for"}
              />
            </>
          ) : (
            <Login loggedIn={loggedIn} setLoggedIn={setLoggedIn} path="/" />
          )}
        </Router>
      </SubContainer>
      <Footer />
    </Container>
  );
}

export default App;
